import { Box, Link, List, ListItem, ListItemText, Typography } from "@mui/material";
import React from "react";
import HeaderSection from "./HeaderSection";
import { text } from "stream/consumers";
import CloseIcon from '@mui/icons-material/Close';

const list = [
    {title:"Enhanced Content Coverage: ", 
    subTitle:"Access a wider range of content than ever before, ensuring you have all the information you need at your fingertips."},
    {title:"New Search & Browse Experience: ", 
    subTitle:"Our latest technology provides a seamless and intuitive search and browse experience, making it easier than ever to find what you're looking for."},
    {title:"More Full text Coverage: ", 
    subTitle:"Dive deeper into content with expanded full-text coverage, allowing you to explore topics comprehensively."},
    {title:"Mobile Applications (Android & iOS): ", 
    subTitle:"Take your experience on the go with our mobile applications, available for both Android and iOS devices. Access your favorite features anytime, anywhere."},
]

const WelcomePage = (props:any) =>{
    return <Box sx={{width:"100%", display:"flex", justifyContent:"center", alignItems:"center", backgroundColor:"white",position:"relative"}}>
        <Box sx={{
            width:'90%',
            marginTop:"40px",
            marginBottom:"40px",
            padding:"55px",
            border:"5px solid #7030a0",
            borderRadius:"10px",
            boxSizing:"border-box",
            
        }}>
            <CloseIcon onClick={props.handleClose} sx={{cursor:"pointer",position:"absolute", top:"15px", right:"15px"}}/>
            <Typography 
                variant="h6" 
                fontFamily={"Quattrocento Sans"} 
                fontWeight={600} 
                sx={{color:"#7030a0"}}>
                Welcome to Our New Beta 
                <Typography 
                    variant="h6" 
                    fontFamily={"Quattrocento Sans"} 
                    fontWeight={600} 
                    sx={{display:"inline",color:"#ed7d31", marginLeft:"8px"}}>
                    J-Gate 3.0
                    </Typography>!
            </Typography>
            <Typography
             variant="h6" 
             fontFamily={"Quattrocento Sans"} 
             fontWeight={600} 
             sx={{color:"#ed7d31", marginTop:"40px"}}>
            Key Features:</Typography>

            
            <List sx={{ listStyle: "decimal", pl: 4 }} component="ol">
                {list.map((item:any)=>{
                    return(
                        <ListItem sx={{ display: "list-item", padding:"0px 16px" }} component="li">
                    <Typography 
                                display={"inline"}
                                fontFamily={"Quattrocento Sans"} 
                                fontWeight={600} 
                                sx={{color:"#7030a0", fontSize:"18px"}}>
                                {item.title}
                        </Typography>
                    <Typography 
                                display={"inline"}
                                fontFamily={"Quattrocento Sans"} 
                                fontWeight={300} 
                                sx={{fontSize:"18px"}}
                                >
                                {item.subTitle}
                        </Typography>
                </ListItem>
                    )
                })}
                
            
            </List>
           
           <Typography 
                fontFamily={"Quattrocento Sans"} 
                fontWeight={300} 
                fontSize={"16px"}
                letterSpacing={"0.2px"}
                sx={{color:"#7030a0", mt:"20px"}}>
                    Plus, numerous additional features!!
            </Typography>
            <Typography 
                fontFamily={"Quattrocento Sans"} 
                fontWeight={300} 
                fontSize={"18px"}
                letterSpacing={"0.2px"}
                sx={{color:"#0070c0", mt:"20px", mb:"10px"}}>
                    {` "We value your opinion! Please take a moment to provide us with your `}
                    <Link href=" http://tinyurl.com/jgate3beta" target="_blank" sx={{color:"#ed7d31", cursor:"pointer"}}>{"Feedback"}</Link> on our product."
            </Typography>
            <Typography fontFamily={"Quattrocento Sans"} 
                fontWeight={600} 
                fontSize={"18px"}
                  display={"inline"}
                  sx={{}}>{"Please Note: "}</Typography> 
            <Typography fontFamily={"Quattrocento Sans"} 
                fontWeight={300} 
                fontSize={"18px"} display={"inline"}>Content updation in Beta version is as on Oct 2023.</Typography>
        </Box>
       
    </Box>
}

export default WelcomePage;